import SpriteSymbol from "../../../../../svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "custom-fields",
  "use": "custom-fields-usage",
  "viewBox": "0 0 17 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 17 16\" id=\"custom-fields\"><g fill=\"none\" fill-rule=\"evenodd\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><g transform=\"translate(1 4)\" stroke=\"currentColor\"><rect width=\"11\" height=\"4.4\" rx=\"1\" /><rect y=\"6.6\" width=\"11\" height=\"4.4\" rx=\"1\" /></g><path class=\"icon--custom-fields__checkmark\" stroke=\"#76CE90\" stroke-width=\"2\" d=\"M16 1l-4.125 4L10 3.182\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol